<template>
  <div class="">
    <div class="text-center">
      <img
        src="/img/logo/logo-symbol.png"
        width="56"
      >
    </div>

    <v-card-title
      class="justify-center pt-6 pb-8 font-weight-bold"
      style="font-size: 25px"
    >
      {{ $t('Users.ResetPassword.Title') }}
    </v-card-title>

    <template v-if="successMessage">
      <v-card-subtitle class="h4 text-center my-3">
        {{ successMessage }}
      </v-card-subtitle>

      <v-card-actions class="d-block text-center px-4">
        <v-btn
          :to="{name: 'Login'}"
          class="px-4 px-sm-8 px-md-12 white--text action-button"
          color="synthesis-ui-green-02"
          depressed
          x-large
          v-text="$t('Common.Button.Login')"
        />
      </v-card-actions>
    </template>

    <template v-else>
      <v-card-subtitle class="h4 text-left my-3">
        {{ $t('Users.ResetPassword.SubTitle') }}
      </v-card-subtitle>

      <v-card-text class="text-left">
        <v-form
          ref="form"
          v-model="isFormValid"
          @submit.prevent
        >
          <label class="field-label">{{ $t('Users.ResetPassword.NewPassword.Label') }}</label>
          <v-text-field
            v-model="model.Password"
            :disabled="isSubmittingData"
            :placeholder="$t('Users.ResetPassword.NewPassword.Placeholder')"
            :rules="model.validator.vuetifyFormFieldRules('Password')"
            autocomplete="new-password"
            name="new-password"
            outlined
            type="password"
            @focusin="errorMessage = ''"
          />

          <div class="my-2" />

          <label class="field-label">{{ $t('Users.ResetPassword.ConfirmPassword.Label') }}</label>
          <v-text-field
            v-model="model.ConfirmPassword"
            :disabled="isSubmittingData"
            :placeholder="$t('Users.ResetPassword.ConfirmPassword.Placeholder')"
            :rules="model.validator.vuetifyFormFieldRules('ConfirmPassword')"
            autocomplete="confirm-new-password"
            name="confirm-new-password"
            outlined
            type="password"
            @focusin="errorMessage = ''"
          />
        </v-form>

        <v-alert
          v-if="errorMessage"
          class="text-left mt-1"
          color="error"
          dense
          text
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="d-block text-right px-4">
        <v-btn
          :disabled="isSubmittingData"
          :to="{name: 'Login'}"
          class="px-4 px-sm-8 px-md-12"
          depressed
          plain
          x-large
          v-text="$t('Common.Button.Cancel')"
        />

        <v-btn
          :disabled="!isFormValid || isSubmittingData"
          :loading="isSubmittingData"
          class="px-4 px-sm-8 px-md-12 white--text action-button"
          color="synthesis-ui-green-02"
          depressed
          x-large
          @click="onSubmitClick"
          v-text="$t('Common.Button.Continue')"
        />
      </v-card-actions>
    </template>
  </div>
</template>

<script>
import i18nRouteMeta      from '@/mixins/i18n/i18nRouteMeta'
import GlobalErrorHandler from '@/mixins/error/globalErrorHandler'
import ResetPasswordModel from '@/api/models/user/ResetPasswordModel'
import API                from '@/api/Api'

export default {
  name      : 'ResetPassword',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta, GlobalErrorHandler],
  props     : {
    token: {
      type   : String,
      default: ''
    }
  },
  data () {
    return {
      isFormValid     : false,
      isSubmittingData: false,
      successMessage  : '',
      errorMessage    : '',
      componentData   : new ResetPasswordModel()
    }
  },
  computed: {
    model: {
      get () {
        return this.componentData
      },
      set (val) {
        this.componentData = val
      }
    }
  },
  watch: {},
  beforeCreate () {},
  created () {
    window.addEventListener('keydown', this.onKeyDown)
    if (this.$refs.form) this.$refs.form.reset()
    this.model.Token = this.token
  },
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeyDown)
  },
  destroyed () {},
  methods: {
    onKeyDown (e) {
      if (e.keyCode === 13 && !this.isSubmittingData) {
        e.preventDefault()
        this.onSubmitClick()
      }
    },

    onSubmitClick () {
      if (this.validateForm()) {
        this.isSubmittingData = true
        this.successMessage = this.errorMessage = ''

        this.model.ResetPassword()
          .then(response => {
            this.handleResponse(response)
          })
          .catch(e => {
            this.handleResponse(e.response)
          })
          .finally(() => {
            if (this.$refs.form) this.$refs.form.reset()
            this.isSubmittingData = false
          })
      }
    },

    handleResponse (response) {
      const data = API.responseData(response)?.resetPassword || {}
      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        this.successMessage = this.$t('Users.ResetPassword.Success.Message')
      } else {
        const errorBucket = this.handleAppError(errors, false)
        this.errorMessage = errorBucket.message
      }
    },

    validateForm (deep = false) {
      this.isFormValid = true
      if (this.$refs?.form) this.isFormValid = this.$refs.form.validate()
      if (this.model?.validator) {
        this.isFormValid = (deep ? this.model.validate() : this.model.validator.validate())
        // eslint-disable-next-line no-console
        console.log(this.model.validator.constructor.name, this.model.errors)
      }
      return this.isFormValid
    }
  }
}

</script>

<style scoped>
/* Change Autocomplete styles in Chrome, Safari & Firefox*/
@-webkit-keyframes autofill {
  0%, 100% {
    color      : #FFFFFF;
    background : transparent;
  }
}

input:-webkit-autofill {
  -webkit-animation-delay     : 1s; /* Safari support - any positive time runs instantly */
  -webkit-animation-name      : autofill;
  -webkit-animation-fill-mode : both;
}
</style>
